import { Stack } from '@chakra-ui/react'
import MonthlyReportHeader from '../../../components/MonthlyReportHeader'
import usePurpleBubblesText from '../../../hooks/usePurpleBubblesText'
import PurpleBubbleContent from '../../../components/PurpleBubbleContent'
import MonthlyReportNavButtons from '../../../components/MonthlyReportNavButtons'
import useReportMonthGuard from '../../../hooks/useReportMonthGuard'
import { useNonSupMedicationsFormState } from './hooks/useNonSupMedicationsFormState'
import { MedicationRegimens } from './components/MedicationRegimens'

export const NonSupMedicationsPage = () => {
  const isValidated = useReportMonthGuard()
  const { handleSubmit, lists } = useNonSupMedicationsFormState()
  const purpleBubbleContent = usePurpleBubblesText('Step-9')

  if (!isValidated) {
    return null // Don't render anything until month is validated
  }

  return (
    <Stack spacing={4}>
      <form onSubmit={handleSubmit}>
        <MonthlyReportHeader title='Non-Supplement Medications' />
      </form>
      {purpleBubbleContent?.text && (
        <PurpleBubbleContent text={purpleBubbleContent.text} />
      )}
      <MedicationRegimens lists={lists} />
      <form onSubmit={handleSubmit}>
        <MonthlyReportNavButtons />
      </form>
    </Stack>
  )
}
